export const linkedin = {
  name: "linkedin" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M4.024 1.5A2.526 2.526 0 0 0 1.5 4.027a2.526 2.526 0 0 0 2.524 2.528 2.527 2.527 0 0 0 2.522-2.528A2.526 2.526 0 0 0 4.024 1.5ZM17.28 8.124c-2.118 0-3.537 1.163-4.118 2.265h-.058V8.473H8.929V22.5h4.349v-6.94c0-1.829.346-3.601 2.611-3.601 2.232 0 2.263 2.092 2.263 3.72v6.82h4.347v-7.693c0-3.777-.813-6.682-5.22-6.682ZM6.2 22.5H1.848V8.473H6.2V22.5Z"/></svg>`,
  keywords: ["linkedin"],
  category: "social" as const,
};
